var _title, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgPick = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 106",
    viewBox: "0 0 24 24",
    x: "0px",
    y: "0px",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Pick")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.298446, 0, 0, 0.298645, -2.860601, -2.995972)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 67 20.61 C 67.15 20.475 67.307 20.348 67.47 20.23 C 65.09 18.19 50.19 6 32.12 11.4 C 30.552 11.906 30.12 13.919 31.341 15.024 C 31.667 15.318 32.075 15.505 32.51 15.56 C 35.99 15.96 51.14 18.38 57.12 30.56 C 57.212 30.433 57.312 30.313 57.42 30.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 69.84 42.58 C 69.727 42.688 69.607 42.788 69.48 42.88 C 81.62 48.88 84.04 64.01 84.48 67.49 C 84.685 69.125 86.583 69.924 87.896 68.929 C 88.246 68.664 88.505 68.298 88.64 67.88 C 94.02 49.81 81.86 34.88 79.81 32.58 C 79.692 32.74 79.565 32.894 79.43 33.04 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 10.82 89.18 C 12.437 90.8 15.063 90.8 16.68 89.18 L 63.68 42.18 L 57.8 36.35 L 10.8 83.35 C 9.18 84.967 9.18 87.593 10.8 89.21 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 69.13 41.88 L 78.68 32.33 C 79.265 31.748 79.593 30.955 79.59 30.13 C 79.6 29.306 79.271 28.514 78.68 27.94 L 72.06 21.32 C 70.849 20.105 68.881 20.105 67.67 21.32 L 58.12 30.87 C 56.911 32.084 56.911 34.046 58.12 35.26 L 64.74 41.88 C 65.969 43.052 67.901 43.052 69.13 41.88 Z"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPick, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Pick.d24393e6.svg";
export { ForwardRef as ReactComponent };